import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/pl'
import locale from 'element-ui/lib/locale'
import store from '@/store/store.js'
import App from './App.vue'
import i18n from '@/languages/languages.js'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import Swal from 'sweetalert2'
import moment from 'moment'
import Pusher from 'pusher-js'
import VueCookie from 'vue-cookie'
import L from 'leaflet'
import { dashboardPermissionRedirect } from '@/utils/checkRoles'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import router from './routes/router'

// library imports
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/sass/paper-dashboard.scss'
// import './assets/sass/demo.scss'
import 'leaflet/dist/leaflet.css'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
import 'leaflet-routing-machine'
import 'leaflet-control-geocoder'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
import { refreshToken } from '@/utils/token'
import { widthChange, widthCheck } from '@/utils/widthCheck'
// model select
import 'vue-search-select/dist/VueSearchSelect.css'

// plugin setup
Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, { sidebarLinks })
Vue.use(VeeValidate, { inject: false })
Vue.use(BootstrapVue)
Vue.use(PerfectScrollbar)
locale.use(lang) // to change if more languages will be available
Vue.prototype.$Swal = Swal
Vue.prototype.$moment = moment
Vue.prototype.$lang = i18n
moment.locale('pl')

// setting modules globally
Vue.prototype.$http = axios
if (window.location.hostname === 'localhost' || (window.location.hostname).substring(0, 3) === '172') {
  // Vue.prototype.$http.defaults.baseURL = 'http://localhost:8000/'
  // Vue.prototype.$http.defaults.baseURL = 'https://drogbruktest.excm.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://drogbruk.excm.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://drogbruk.edusky.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://poxbox.excm.pl/core/public/index.php/'
  Vue.prototype.$http.defaults.baseURL = 'https://iam.edusky.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://so.edusky.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'http://zgloszenia.arcop.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'http://localhost/skyOfficeSymfony/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'http://test.arcop.pl/core/public/index.php/'
} else {
  // Vue.prototype.$http.defaults.baseURL = 'https://drogbruktest.excm.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://drogbruk.excm.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://drogbruk.edusky.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://poxbox.excm.pl/core/public/index.php/'
  Vue.prototype.$http.defaults.baseURL = 'https://iam.edusky.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'https://so.edusky.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'http://zgloszenia.arcop.pl/core/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'http://localhost/skyOfficeSymfony/public/index.php/'
  // Vue.prototype.$http.defaults.baseURL = 'http://test.arcop.pl/core/public/index.php/'
}
Vue.prototype.$http.defaults.headers.common = {
  'Authorization': 'Bearer ' + VueCookie.get('excm_accessToken'),
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json'
}

// ====change page title after route change
router.afterEach((to, from) => {
  let i18n = store.state.i18n
  if (router.history.current.path !== '/login' && !VueCookie.get('excm_accessToken')) {
    router.push('/login')
  }
  if (router.history.current.path === '/' && VueCookie.get('excm_accessToken')) {
    // router.push('/admin/timetable/dashboard')
    router.push(dashboardPermissionRedirect())
  }
  if (router.history.current.path !== '/login' && from.name !== 'Login' && VueCookie.get('excm_accessToken') && to.name) {
    refreshToken()
  }
  if (to.meta.title) {
    // if (Object.keys(i18n).length === 0) {
    //   i18n = i18n
    // }
    document.title = i18n.t(to.meta.title) + ' - ' + store.state.site_name
  } else {
    document.title = store.state.site_name
  }
})
setInterval(function () { // check validation token
  if (!VueCookie.get('excm_accessToken')) {
    if (router.history.current.path !== '/login' && router.history.current.path !== '/register') {
      router.push('/login')
    }
  } else {
    // update header to send
    if (router.history.current.path === '/login' && VueCookie.get('excm_accessToken')) {
      router.push(dashboardPermissionRedirect())
    } else if (router.history.current.path === '/login' && VueCookie.get('excm_accessToken') && VueCookie.get('surname')) {
      router.push(dashboardPermissionRedirect())
    }
    Vue.prototype.$http.defaults.headers.common = {
      'Authorization': 'Bearer ' + VueCookie.get('excm_accessToken')
    }
  }
  if (VueCookie.get('expires_in')) {
    let time = moment.unix(VueCookie.get('expires_in'))
    store.state.loginTime = moment(time).locale('pl').fromNow()
  }
}, 250)

initProgress(router)

// Pusher initialization
store.state.Pusher = new Pusher('2e6dc09272a01b824314', {
  cluster: 'eu',
  forceTLS: true
})

widthChange()
widthCheck()

axios.defaults.headers.common = {
  'Authorization': 'Bearer ' + VueCookie.get('excm_accessToken'),
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json'
}

// eslint-disable-next-line
delete L.Icon.Default.prototype._getIconUrl
// eslint-disable-next-line
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n,
  store
})
